import { useMoveToSearch } from './moveToSearch';
import { useMoveToSearchResult } from './moveToSearchResult';

export const useSearchNavigator = () => {
  const moveToSearch = useMoveToSearch();
  const moveToSearchResult = useMoveToSearchResult();

  return {
    moveToSearch,
    moveToSearchResult,
  };
};
